











import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import { Controlador as Model, ControladorDeCurso } from '../curso-controlador';
import { Recurso } from '@/__env/lib/Cursos/Recursos';
import { Wait } from '@/__env/ext';
import recursos from './curso-recursos.vue';
import { Pregunta } from '@/__env/lib/Cursos/Preguntas';
import { Curso } from '@/__env/lib/Cursos';
import { Resultado } from '@/__env/lib/Cursos/Resultado';
@Component( {
    name: "Componente",
    props: {},
    components: {
        recursos
    }
} )
export default class Componente extends Vue
{
    public get Controlador(): ControladorDeCurso { return Model; }
    public get Curso(): Curso { return Model.Curso; }
    public get Resultado(): Resultado { return Model.Resultado; }

}
